/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IncidentReportFromJSON, IncidentReportToJSON, } from './IncidentReport';
import { RelationStatusFromJSON, RelationStatusToJSON, } from './RelationStatus';
import { UserProfileFromJSON, UserProfileToJSON, } from './UserProfile';
/**
 * Check if a given object implements the IncidentReportRelation interface.
 */
export function instanceOfIncidentReportRelation(value) {
    let isInstance = true;
    return isInstance;
}
export function IncidentReportRelationFromJSON(json) {
    return IncidentReportRelationFromJSONTyped(json, false);
}
export function IncidentReportRelationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'createdBySubject': !exists(json, 'createdBySubject') ? undefined : json['createdBySubject'],
        'updatedBySubject': !exists(json, 'updatedBySubject') ? undefined : json['updatedBySubject'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'incidentReport': !exists(json, 'incidentReport') ? undefined : IncidentReportFromJSON(json['incidentReport']),
        'relatedIncidentReportId': !exists(json, 'relatedIncidentReportId') ? undefined : json['relatedIncidentReportId'],
        'relatedIncidentReport': !exists(json, 'relatedIncidentReport') ? undefined : IncidentReportFromJSON(json['relatedIncidentReport']),
        'createdByUserProfileId': !exists(json, 'createdByUserProfileId') ? undefined : json['createdByUserProfileId'],
        'createdByUserProfile': !exists(json, 'createdByUserProfile') ? undefined : UserProfileFromJSON(json['createdByUserProfile']),
        'status': !exists(json, 'status') ? undefined : RelationStatusFromJSON(json['status']),
        'reviewedAt': !exists(json, 'reviewedAt') ? undefined : (json['reviewedAt'] === null ? null : new Date(json['reviewedAt'])),
    };
}
export function IncidentReportRelationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'createdBySubject': value.createdBySubject,
        'updatedBySubject': value.updatedBySubject,
        'incidentReportId': value.incidentReportId,
        'incidentReport': IncidentReportToJSON(value.incidentReport),
        'relatedIncidentReportId': value.relatedIncidentReportId,
        'relatedIncidentReport': IncidentReportToJSON(value.relatedIncidentReport),
        'createdByUserProfileId': value.createdByUserProfileId,
        'createdByUserProfile': UserProfileToJSON(value.createdByUserProfile),
        'status': RelationStatusToJSON(value.status),
        'reviewedAt': value.reviewedAt === undefined ? undefined : (value.reviewedAt === null ? null : value.reviewedAt.toISOString()),
    };
}
